import { ELoginAs } from '@aqx-core/common/api/auth';
import { authenticationViewController } from '@aqx-core/common/services/auth/controller';

import { validateCompanyAccess } from '../company-access';

export const normalizeSelectedLoginTab = ({
  selectedTab,
  companyAccess
}: {
  selectedTab: ELoginAs | undefined;
  companyAccess: ReturnType<typeof validateCompanyAccess>;
}) => {
  const { hasMT4LiveLoginConfig, hasMT4DemoLoginConfig, hasMT5LiveLoginConfig, hasMT5DemoLoginConfig } = companyAccess;

  if (!selectedTab) {
    return selectedTab;
  }

  if (selectedTab === ELoginAs.MT4_LIVE || selectedTab === ELoginAs.MT5_LIVE) {
    const liveLoginType = authenticationViewController.getLiveLoginTypeFromCompanyAccess({
      hasMT5LiveLoginConfig,
      hasMT4LiveLoginConfig
    });
    return liveLoginType || selectedTab;
  }

  if (selectedTab === ELoginAs.MT4_DEMO || selectedTab === ELoginAs.MT5_DEMO) {
    const demoLoginType = authenticationViewController.getDemoLoginTypeFromCompanyAccess({
      hasMT5DemoLoginConfig,
      hasMT4DemoLoginConfig
    });
    return demoLoginType || selectedTab;
  }

  return selectedTab;
};
